import React, { useState } from "react";

import { useTheme } from "@mui/material/styles";
import { Box, TextField, Typography, IconButton, InputAdornment, } from "@mui/material";

import { ReactComponent as HideIcon } from "assets/images/icons/icn_input_hide.svg";
import { ReactComponent as ShowIcon } from "assets/images/icons/icn_input_show.svg";

const InputField = ({
    type = "text",
    value,
    onChange,
    maxLength,
    disabled = false,
    helperText,
    isValid = true,
    errorHelperText
}) => {
    const theme = useTheme();
    const [focused, setFocused] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    border: !isValid ?
                        `1px solid ${theme.palette.primary.redPrimary}` :
                        `1px solid ${focused
                            ? theme.palette.primary.greyPrimary
                            : theme.palette.primary.greyFifth}`,
                    borderRadius: "8px",
                    padding: "4px 8px",
                    gap: "4px",
                    margin: "5px",
                    "&:hover": {
                        borderColor: !isValid ? theme.palette.primary.redPrimary : theme.palette.primary.mainHover,
                    },
                }}
            >
                <TextField
                    fullWidth
                    sx={{
                        "& .MuiInputBase-root": {
                            textAlign: "center",
                        },
                        "& .MuiInputBase-input": {
                            padding: 0,
                            fontSize: theme.typography.customFontSize[2],
                            color: theme.palette.primary.greyPrimary
                        },
                        "& .MuiInput-underline:before, & .MuiInput-underline:after": {
                            borderBottom: "none",
                        },
                        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                            borderBottom: "none",
                        },
                        backgroundColor: "transparent",
                    }}
                    inputProps={{ maxLength }}
                    type={(type === "password" && !showPassword ? "password" : "text") || type}
                    value={value}
                    disabled={disabled}
                    onFocus={() => setFocused(true)}
                    onBlur={() => setFocused(false)}
                    onChange={(e) => onChange(e.target.value)}
                    variant="standard"
                    autoComplete="off"
                    InputProps={type === "password" ? {
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={() => setShowPassword((prev) => !prev)}
                                    edge="end"
                                    sx={{
                                        padding: 2,
                                        "&:hover": {
                                            backgroundColor:
                                                theme.palette.primary.transparent,
                                        },
                                        "&.Mui-focusVisible": {
                                            backgroundColor:
                                                theme.palette.primary.transparent,
                                        },
                                    }}
                                >
                                    {showPassword ? <ShowIcon /> : <HideIcon />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    } : {}}
                />
            </Box>

            {isValid && helperText && (
                <Typography
                    sx={{
                        fontSize: theme.typography.customFontSize[0],
                        color: theme.palette.primary.greySecound,
                        marginTop: "4px",
                        marginLeft: "4px",
                    }}
                >
                    {helperText}
                </Typography>
            )}
            {!isValid && errorHelperText && (
                <Typography
                    sx={{
                        fontSize: theme.typography.customFontSize[3],
                        color: theme.palette.primary.redPrimary,
                        marginTop: "4px",
                        marginLeft: "4px",
                    }}
                >
                    {errorHelperText}
                </Typography>
            )}
        </>
    );
};

export default InputField;
